// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-info[data-v-387b9ebc]{border:1px solid #474747;margin:.1em}span[data-v-387b9ebc]{font-size:14px}.order-info-title[data-v-387b9ebc]{text-align:left;line-height:50px;padding-left:1.5em;font-weight:700}.order-info[data-v-387b9ebc]{border:1px solid #474747;margin:.1em}.horizontal-line[data-v-387b9ebc]{border:1px solid #e3e0e0;width:98%;margin-left:1%}", ""]);
// Exports
module.exports = exports;
